import { AxiosInstance, AxiosResponse } from 'axios';
import ERROR_HANDLER from './errorHandler';
import isInWhiteList, { noneAccessTokenUrlList } from '../whitelist';
import createRequest from '../createRequest';
import { filteredNullFromResponse } from '@/utils/filteredNullFromResponse';
import { COUNTRY } from '@/utils/locale';
import { UseLiveChatSDKApp } from '@/config/core';
import { getLiveChatSDKHttpHeaders } from '@/utils/liveChatToken';
import { mdapResponseInterceptors } from '@/utils/mdap/reporter';
import { apiInterceptors } from '@/utils/report';
import { saasDomainInterceptor } from '@/services/interceptors';

export const baseURL = '/chat/v1/';

export const fetch: AxiosInstance = createRequest({ baseURL });


const handleSuccess = (response: AxiosResponse): Promise<AxiosResponse<any>> => {
  const { status, data: res } = response;
  apiInterceptors(response);
  mdapResponseInterceptors(response);

  if (status === 200 && res) {
    const CODE = res.code;

    if (CODE !== 0) {
      ERROR_HANDLER[CODE] && ERROR_HANDLER[CODE]();
    }

    return Promise.resolve(filteredNullFromResponse(res));
  } else {
    const error = new Error(`Request failed with status code ${status || 'UNKNOWN'}`);
    ((error as unknown) as any).response = response;
    return Promise.reject(error);
  }
};

const handleError = (err: any) => {
  const {
    response = {},
    message = '',
  } = err;

  apiInterceptors(err);

  // 目前只为了处理heartbeats超时失败不报错的情况
  if (isInWhiteList(err.config && err.config.url)) {
    return Promise.reject(err);
  }

  if (response.status) {
    // 5xx: Server Error
    if ((response.status + '').indexOf('5') === 0) {
      ERROR_HANDLER.SERVER_ERROR();
    }
  } else if (message?.includes('Network Error')) {
    // Network Error handler
    ERROR_HANDLER.NETWORK_ERROR();
  } else if (message?.includes('timeout')) {
    // timeout error handler
    ERROR_HANDLER.TIMEOUT();
  }

  return Promise.reject(err);
};

fetch?.interceptors?.request?.use?.(config => {
  config.headers.common['shopee-region'] = COUNTRY;
  if (UseLiveChatSDKApp.is()) {
    const tokens = getLiveChatSDKHttpHeaders();

    // 不传 chat access token
    if (noneAccessTokenUrlList.includes(config.url!)) {
      // @ts-ignore;
      delete tokens['chat-access-token'];
    }

    Object.entries(tokens).map(([key, value]) => {
      config.headers.common[key] = value || '';
    });
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  config.requestStartTime = Date.now();
  return config;
});

fetch?.interceptors?.request?.use?.(saasDomainInterceptor);

fetch?.interceptors?.response?.use?.(handleSuccess, handleError);
